import React from 'react';
import { EnterpriseSnapshot } from '../components/hq/EnterpriseSnapshot';
import { SiteStatusGrid } from '../components/hq/SiteStatusGrid';
import { SLARiskLeaderboard } from '../components/hq/SLARiskLeaderboard';
import { CrossSiteAlertFeed } from '../components/hq/CrossSiteAlertFeed';
import { VehicleWatchlist } from '../components/hq/VehicleWatchlist';
import { GuardCoverageOverview } from '../components/hq/GuardCoverageOverview';
import { Button } from '../components/ui/Button';
import { Download, Settings, FileText } from 'lucide-react';
interface HQDashboardProps {
  onViewSite: (siteId: string) => void;
}
export function HQDashboard({
  onViewSite
}: HQDashboardProps) {
  return <div className="min-h-screen bg-[#0f1115] text-gray-100 font-sans selection:bg-amber-500/30 p-6 space-y-6 max-w-[1920px] mx-auto" data-id="element-481">
      {/* Section 1: Enterprise Snapshot */}
      <section data-id="element-482">
        <EnterpriseSnapshot data-id="element-483" />
      </section>

      {/* Main Grid Layout */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6" data-id="element-484">
        {/* Left Column: Site Grid (8 cols) */}
        <div className="xl:col-span-8 space-y-6" data-id="element-485">
          <section data-id="element-486">
            <div className="flex items-center justify-between mb-4" data-id="element-487">
              <h2 className="text-lg font-semibold text-white" data-id="element-488">
                Site Status Overview
              </h2>
              <div className="flex gap-2" data-id="element-489">
                <Button variant="outline" size="sm" className="h-8 text-xs" data-id="element-490">
                  <Settings className="h-3 w-3 mr-1.5" data-id="element-491" /> Configure View
                </Button>
                <Button variant="outline" size="sm" className="h-8 text-xs" data-id="element-492">
                  <Download className="h-3 w-3 mr-1.5" data-id="element-493" /> Export Report
                </Button>
              </div>
            </div>
            <SiteStatusGrid onViewSite={onViewSite} data-id="element-494" />
          </section>

          <section data-id="element-495">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 h-[400px]" data-id="element-496">
              <VehicleWatchlist data-id="element-497" />
              <GuardCoverageOverview data-id="element-498" />
            </div>
          </section>
        </div>

        {/* Right Column: Feeds & Lists (4 cols) */}
        <div className="xl:col-span-4 flex flex-col gap-6" data-id="element-499">
          <div className="flex-1 min-h-[400px]" data-id="element-500">
            <SLARiskLeaderboard data-id="element-501" />
          </div>
          <div className="flex-1 min-h-[400px]" data-id="element-502">
            <CrossSiteAlertFeed data-id="element-503" />
          </div>

          {/* Quick Actions Panel */}
          <div className="bg-[#1a1d23] border border-gray-800 rounded-lg p-4" data-id="element-504">
            <h3 className="font-semibold text-white mb-3 text-sm" data-id="element-505">
              Quick Actions
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-506">
              <Button variant="outline" size="sm" className="justify-start text-xs" data-id="element-507">
                <FileText className="h-3 w-3 mr-2" data-id="element-508" /> Daily Report
              </Button>
              <Button variant="outline" size="sm" className="justify-start text-xs" data-id="element-509">
                <Settings className="h-3 w-3 mr-2" data-id="element-510" /> Alert Config
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}